import { useMemo } from "react";
import { jwtDecode } from "jwt-decode";
import { useAuthContext } from "@app/authContext";

interface KeycloakTokenPayload {
  realm_access?: {
    roles?: string[];
  };
}

export function useRealmRoles() {
  const { auth } = useAuthContext();
  const accessToken = auth?.access_token ?? "";

  const { roles, hasRole } = useMemo(() => {
    if (!accessToken) {
      return {
        roles: [] as string[],
        hasRole: () => false,
      };
    }

    try {
      const decoded = jwtDecode<KeycloakTokenPayload>(accessToken);
      const roles = decoded.realm_access?.roles ?? [];

      return {
        roles,
        hasRole: (role: string) => roles.includes(role),
      };
    } catch (e) {
      console.warn("Не удалось декодировать accessToken", e);
      return {
        roles: [] as string[],
        hasRole: () => false,
      };
    }
  }, [accessToken]);

  return { roles, hasRole };
}
